<bs-linear-combo-bet-container
    [oddsDisplayFormat]="oddsDisplayFormat"
    [picksTemplate]="picks"
    [detailsTemplate]="details"
    [infoMessageTemplate]="infoMessage"
    [removeButtonStyle]="removeButtonStyle" />

<ng-template #infoMessage let-close="close">
    <bs-digital-betbuilder-info-message (close)="close()" />
</ng-template>

<ng-template #picks>
    @if (currentPick(); as pick) {
        <bs-linear-bet-builder-pick-display
            [pick]="pick"
            [selectionState]="selectionState"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [showEditButton]="true" />
    }
</ng-template>

<ng-template #details>
    @if (currentPick(); as pick) {
        <bs-linear-bet-builder-selections-list [pick]="pick" [inlineDetails]="true" />
    }
</ng-template>
